import {React,useRef,useState,useEffect} from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { DataGrid,  GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useParams } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import ViewCoupans from '../../views/PartnerView/ViewCoupans';
const ViewsCoupansComponent=()=>{
    const userType = localStorage.getItem('userType'); 
    const [loading, setLoading] = useState(true); 
    const didFetch = useRef(false);
    const { id, edit } = useParams();
    const [CoupanData, setCoupanData] = useState(null);
    const { getallcouponadmin } = useServiceContext(); 
    const getData = async () => { 
        try { 
            const data = await getallcouponadmin();
            setCoupanData(data); 
            setLoading(false); 
            } catch (error) { 
                console.log('Error fetching data:', error.response?.data);
                 setLoading(false); 
            } 
    }; 
    useEffect(() => { 
        debugger;
        if (!didFetch.current) 
            { 
                getData();
                didFetch.current = true;
            } 
            //console.log(CoupanData);
    });
        return (
            
             <div> {!loading && <ViewCoupans/>} </div> 
        ); 

}
export default ViewsCoupansComponent;